/** Ασφαλές εσωτερικό path επιστροφής (όχι εξωτερικό URL). */
export function isSafeAppReturnPath(path: string): boolean {
  if (!path.startsWith('/') || path.startsWith('//')) return false
  return !path.includes('://')
}

export function buildNewCustomerUrl(returnTo: string): string {
  const clean = stripCustomerIdFromPath(returnTo)
  return `/customers/new?returnTo=${encodeURIComponent(clean)}`
}

export function stripCustomerIdFromPath(pathWithSearch: string): string {
  const q = pathWithSearch.indexOf('?')
  if (q < 0) return pathWithSearch
  const pathname = pathWithSearch.slice(0, q)
  const sp = new URLSearchParams(pathWithSearch.slice(q + 1))
  sp.delete('customerId')
  const qs = sp.toString()
  return qs ? `${pathname}?${qs}` : pathname
}

export function appendCustomerIdToReturn(
  returnTo: string,
  customerId: string,
): string {
  const q = returnTo.indexOf('?')
  const pathname = q >= 0 ? returnTo.slice(0, q) : returnTo
  const sp = new URLSearchParams(q >= 0 ? returnTo.slice(q + 1) : '')
  sp.set('customerId', customerId)
  const qs = sp.toString()
  return `${pathname}?${qs}`
}

export function resolveCustomerCreateReturn(searchParams: URLSearchParams): {
  returnTo: string | null
  /** Σύντομη φόρμα (όπως capture) — υποχρεωτικό τηλέφωνο. */
  simplifiedForm: boolean
} {
  const returnToRaw = searchParams.get('returnTo')?.trim() ?? ''
  const simplifiedForm = searchParams.get('from') === 'capture'
  if (returnToRaw && isSafeAppReturnPath(returnToRaw)) {
    return { returnTo: returnToRaw, simplifiedForm }
  }
  if (searchParams.get('from') === 'capture') {
    return { returnTo: '/offers/capture', simplifiedForm: true }
  }
  return { returnTo: null, simplifiedForm: false }
}
